import React, { useState } from "react";

import 'bootstrap/dist/css/bootstrap.min.css';
import Button from 'react-bootstrap/Button';

const axios = require('axios').default;


function Dashboard() {

  const [online, setOnline] = useState("");

  const checkOnline = (station_id) => {
    let url = process.env.REACT_APP_API_SERVER + "/station_api_check_online";

    axios.post(url, {
      "action": "CHECK_ONLINE",
      "station_id": station_id    
    })
      .then(function (response) {
        let d = response.data;
        if ((d.station_id === station_id) && (d.action === "CHECK_ONLINE")){
          setOnline(d.response);
        }
      })
      .catch(function (error) {
        console.log(error);
      });    

  }


  return (
    <div>
      <div>
        Logged in as
        <div>
          {/* <Button className="dashboard__btn" onClick={logout}>Logout</Button> */}
        </div>
        <div>
          <Button className="dashboard__btn" onClick={(e) => {checkOnline("NUS_BIN_1")}}>Check Online</Button>
        </div>
        <div>{online}</div>





      </div>
    </div>
  );
}
export default Dashboard;